import { render, staticRenderFns } from "./CorrespondenceList.vue?vue&type=template&id=3ec786a2&scoped=true"
import script from "./CorrespondenceList.vue?vue&type=script&lang=ts"
export * from "./CorrespondenceList.vue?vue&type=script&lang=ts"
import style0 from "./CorrespondenceList.vue?vue&type=style&index=0&id=3ec786a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec786a2",
  null
  
)

export default component.exports